import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import CountryGrid from './components/CountryGrid';
import Services from './components/Services';
import Newsletter from './components/Newsletter';
import EmailThankYou from './components/EmailThankYou';
import Consultation from './components/Consultation';
import ConsultationThankYou from './components/ConsultationThankYou';
import ConsultationPaymentThankYou from './components/ConsultationPaymentThankYou';
import MexicoResidency from './components/MexicoResidency';
import MexicoThankYou from './components/MexicoThankYou';
import UAE from './components/UAE';
import DubaiBuyVsRent from './components/DubaiBuyVsRent';
import DubaiCalculatorSuccess from './components/DubaiCalculatorSuccess';
import About from './components/About';
import TermsAndConditions from './components/TermsAndConditions';
import WhatsAppSubscription from './components/WhatsAppSubscription';
import WhatsAppThankYou from './components/WhatsAppThankYou';
import IndonesiaBankAccount from './components/IndonesiaBankAccount';
import IndonesiaBankThankYou from './components/IndonesiaBankThankYou';
import IndonesiaPaymentThankYou from './components/IndonesiaPaymentThankYou';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <ul className="nav-links">
            <li><Link to="/">Start Here</Link></li>
            <li><Link to="/relocation-services">Services</Link></li>
            <li><Link to="/uae">UAE Setup Guide</Link></li>
            <li><Link to="/mexico-residency">Mexico Residency</Link></li>
            <li><Link to="/newsletter">Newsletter</Link></li>
            <li><Link to="/consultation">Consulting</Link></li>
          </ul>
        </nav>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/residency-database" element={<CountryGrid />} />
            <Route path="/relocation-services" element={<Services />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/email-success" element={<EmailThankYou />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/consultation-thank-you" element={<ConsultationThankYou />} />
            <Route path="/consultation-payment-thank-you" element={<ConsultationPaymentThankYou />} />
            <Route path="/mexico-residency" element={<MexicoResidency />} />
            <Route path="/mexico-thank-you" element={<MexicoThankYou />} />
            <Route path="/uae" element={<UAE />} />
            <Route path="/dubai-calculator" element={<DubaiBuyVsRent />} />
            <Route path="/dubai-calculator-success" element={<DubaiCalculatorSuccess />} />
            <Route path="/whatsapp-access" element={<WhatsAppSubscription />} />
            <Route path="/whatsapp-thank-you-5kQ4gzgcg05yfL1ccj6Ri0j" element={<WhatsAppThankYou />} />
            <Route path="/indonesia-bank-account" element={<IndonesiaBankAccount />} />
            <Route path="/indonesia-bank-thank-you" element={<IndonesiaBankThankYou />} />
            <Route path="/indonesia-payment-thank-you" element={<IndonesiaPaymentThankYou />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<TermsAndConditions />} />
          </Routes>
        </main>
        <footer className="site-footer">
          <div className="footer-content">
            <div className="footer-links">
              <Link to="/about">About</Link>
              <span className="separator">•</span>
              <Link to="/terms">Terms & Conditions</Link>
            </div>
            <p className="copyright">© {new Date().getFullYear()} All rights reserved</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
